import { getData, postApplicationJson } from '@gef-ui/middleware-api/auth/oauth2/facade';
import { getBaseWithPostfix } from '@gef-ui/redux-common/selectors/urls';
import { createAction } from '@gef-ui/utils/fsaActions';
import prop from "ramda/es/prop";
import { actionTypes } from '../constants';
export const getIasc = (iascId)=>getData({
        endpoint: getBaseWithPostfix(`/iasc/${iascId}`),
        actionName: 'getIasc',
        actions: {
            onSuccess: createAction(actionTypes.SAVE_IASC_DATA, prop('body'))
        }
    });
export const saveIasc = (body)=>postApplicationJson({
        endpoint: getBaseWithPostfix('/iasc'),
        actionName: 'saveIasc',
        body,
        actions: {
            onSuccess: createAction(actionTypes.SAVE_IASC_ID, prop('body'))
        }
    });
